import React, { useMemo } from 'react';
import { useTranscript } from '../../context/TranscriptContext';
import { callerSentimentModel } from '../../lib/sentimentTrend';
import CallerSentiment from '../Sentiment/CallerSentiment';

// Phase 3 (2026-09-14): live sentiment, one entry per role, from the Contact
// Lens label of each role's utterances — no 0–100 score, deliberately.
//
// Console v3 sentiment piece (2026-09-21), matching the design's pattern:
// - Customer: current label + a word-sized trend sparkline + a plain-language
//   trend sentence (a sequence, never a claimed cause). Built by
//   lib/sentimentTrend.js and drawn by components/Sentiment/CallerSentiment.jsx,
//   a self-contained component this rail only places.
// - Agent: the label only. The trend arrow is gone, and nothing is added in its
//   place — "Calm · warm"-style tone words are not in Contact Lens's data.
// Renders nothing until at least one role has a labelled utterance.
const LABEL_TEXT = { POSITIVE: 'Positive', NEUTRAL: 'Neutral', NEGATIVE: 'Negative' };

export default function SentimentPills() {
  const { lines, sentiment } = useTranscript();
  const caller = useMemo(() => callerSentimentModel(lines), [lines]);
  const agent = sentiment?.agent;
  if (!caller && !(agent && agent.label)) return null;

  return (
    <div className="lr-section">
      <span className="lr-label">Live sentiment</span>
      <div className="sent-pills">
        {caller && (
          <div className="sent-caller">
            <span className="sent-who">Customer</span>
            <CallerSentiment model={caller} />
          </div>
        )}
        {agent && agent.label && (
          <div className="sent-row">
            <span className="sent-who">Agent</span>
            <span className={`sent-pill ${agent.label.toLowerCase()}`} title={`Latest line at ${agent.at ?? '—'}`}>
              {LABEL_TEXT[agent.label] ?? agent.label}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
